import Button from "./Button";
import { getStripeJsLoadErrorMessage } from "~/lib/stripe/stripeJsLoad";

interface StripeJsLoadErrorProps {
	canUsePayPal?: boolean;
	onRetry: () => void;
}

/**
 * Visible fallback when Stripe.js fails to load from the CDN.
 *
 * @param props.canUsePayPal - Mention PayPal as an alternative when offered
 * @param props.onRetry - Re-attempt loading Stripe.js
 */
const StripeJsLoadError = ({
	canUsePayPal,
	onRetry,
}: StripeJsLoadErrorProps) => {
	return (
		<div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm dark:border-red-800 dark:bg-red-950/40 dark:text-red-200">
			<p>{getStripeJsLoadErrorMessage({ canUsePayPal })}</p>
			<Button className="mt-2 w-full" type="button" onClick={onRetry}>
				Retry
			</Button>
		</div>
	);
};

export default StripeJsLoadError;
